export default __webpack_public_path__ + "static/media/kitchen4-afterA.e1a36c45.jpg";